import { jsxs, jsx, Fragment } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { CustomDropzone } from "./core/custom-dropzone.es.js";
import { DropzonePhase } from "./core/dropzone.enum.es.js";
import { handleOnDropEventAndReturnNewStatus, handleClearButtonClickEventAndReturnNewStatus } from "./core/handler-functions.es.js";
import { DropzoneClearButton } from "./elements/clear-button.es.js";
import { DropzoneContainer } from "./elements/main-container.es.js";
import { DropzoneMessage } from "./elements/message-container.es.js";
import { doesArrayContainProvidedElement } from "../../utils/condition-checkers/condition-checkers.es.js";
import { useState, useCallback } from "react";
import { useDropzone } from "../../../node_modules/react-dropzone/dist/es/index.es.js";
function Dropzone({
  status,
  uploadButtonText,
  loadingText,
  modifyButtonText,
  confirmButtonText,
  onDrop,
  onDropError,
  onClear,
  onClearError,
  onConfirm,
  onConfirmError,
  onModify,
  onModifyError,
  clearButtonId,
  id,
  ...rest
}) {
  const [dropzoneStatus, setDropzoneStatus] = useState({
    phase: (status == null ? void 0 : status.phase) ?? DropzonePhase.Empty,
    message: status == null ? void 0 : status.message,
    acceptedFiles: (status == null ? void 0 : status.acceptedFiles) ?? []
  });
  const isInputDisabled = doesArrayContainProvidedElement([DropzonePhase.Valid, DropzonePhase.ConfirmedFiles], dropzoneStatus.phase);
  const isClearButtonDisabled = isClearButtonFunctionalityDisabled(dropzoneStatus);
  const onDropHandler = useCallback(function onDropEventHandler(acceptedFiles, fileRejections, event) {
    const newStatus = handleOnDropEventAndReturnNewStatus(acceptedFiles, fileRejections, event, onDrop, onDropError);
    setDropzoneStatus(newStatus);
  }, [setDropzoneStatus, onDrop, onDropError]);
  const {
    getRootProps,
    getInputProps
  } = useDropzone({
    noClick: isInputDisabled,
    noDrag: isInputDisabled,
    noDragEventsBubbling: isInputDisabled,
    noKeyboard: true,
    onDrop: onDropHandler,
    ...rest
  });
  const isPhaseLoading = dropzoneStatus.phase === DropzonePhase.Loading;
  const onClearClickHandler = useCallback(async function handleClearButton(event) {
    const newStatus = await handleClearButtonClickEventAndReturnNewStatus(event, onClear, onClearError);
    if (newStatus) {
      setDropzoneStatus(newStatus);
    }
  }, [setDropzoneStatus, onClear, onClearError]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(CustomDropzone, { id, ...getRootProps(), status: dropzoneStatus, children: [
      /* @__PURE__ */ jsx("input", { ...getInputProps(), className: "dropzone-input" }),
      !isClearButtonDisabled && /* @__PURE__ */ jsx(DropzoneClearButton, { clearButtonId, onClick: onClearClickHandler }),
      /* @__PURE__ */ jsx(DropzoneContainer, { uploadButtonText, loadingText, isLoading: isPhaseLoading, acceptedFiles: dropzoneStatus.acceptedFiles })
    ] }),
    dropzoneStatus.message && /* @__PURE__ */ jsx(DropzoneMessage, { color: dropzoneStatus.phase, message: dropzoneStatus.message })
  ] });
}
function isClearButtonFunctionalityDisabled(dropzoneStatus) {
  const isDisallowedPhaseToShowButton = doesArrayContainProvidedElement([DropzonePhase.Valid, DropzonePhase.Loading, DropzonePhase.ConfirmedFiles], dropzoneStatus.phase);
  return isDisallowedPhaseToShowButton;
}
export {
  Dropzone
};
//# sourceMappingURL=dropzone.es.js.map
